/*
  orlea-dd-teintes.js — Dropdown de teintes de la PDP (decision Simon
  2026-08-07, maquette v3 : mini-photo 34px + nom, comme la liste d'avant
  mais compacte).

  PHILOSOPHIE (la meme que l'overlay) : UI custom, PLOMBERIE FLAUNT INTACTE.
  Le variant-picker natif (radios + swatch_label) reste la source de verite :
  on le LIT pour construire le dropdown, on le MASQUE, et un clic d'option
  CLIQUE le label natif -> Flaunt fait son re-render AJAX (prix, URL, image)
  et la synchro galerie (orlea-galerie.js) suit toute seule via le change.

  🔴 MASQUAGE EN INLINE, PAS SEULEMENT EN CSS. La regle
  `.product_option_values_wrapper{display:none!important}` de
  orlea-dd-teintes.css etait servie, compilee, matchee — et le wrapper restait
  `flex` quand meme (cascade fantome non elucidee, mesuree le 2026-08-07).
  Un style INLINE avec priorite important gagne, verifie en reel. On le repose
  a chaque reconstruction (le re-render Flaunt recree le wrapper sans style).

  🔴 RE-RENDER : Flaunt recree le variant-picker a chaque changement de
  teinte -> reconstruction idempotente par MutationObserver (flag oddFait
  pose sur le wrapper COURANT ; un wrapper neuf n'a pas le flag).
  🔴 TOUS les ecouteurs sont delegues depuis document : rien ne se perd au
  re-render, rien ne s'empile.
  PDP seulement : tout est gate sur la presence de .orlea-pdp-shades.
*/
(function () {
  'use strict';

  function racine() { return document.querySelector('.orlea-pdp-shades'); }
  function wrapper() { var r = racine(); return r ? r.querySelector('.product_option_values_wrapper') : null; }
  function lesRadios() { var w = wrapper(); return w ? w.querySelectorAll('input[type="radio"]') : []; }

  function infoDe(r, shades) {
    var label = (r.nextElementSibling && r.nextElementSibling.classList.contains('swatch_label'))
      ? r.nextElementSibling
      : shades.querySelector('label[for="' + r.id + '"]');
    var inner = label ? label.querySelector('.inner_swatch') : null;
    var bg = inner ? getComputedStyle(inner).backgroundImage : 'none';
    return { nom: r.value, bg: bg, label: label, disabled: r.disabled };
  }

  function majBtn() {
    var shades = racine(); if (!shades) return;
    var dd = shades.querySelector('.odd'); if (!dd) return;
    var w = wrapper(); if (!w) return;
    var radios = lesRadios(); if (!radios.length) return;
    var checked = w.querySelector('input[type="radio"]:checked') || radios[0];
    var inf = infoDe(checked, shades);
    dd.querySelector('.odd-nom').textContent = inf.nom;
    var m = dd.querySelector('.odd-btn .odd-mini');
    m.style.backgroundImage = (inf.bg && inf.bg !== 'none') ? inf.bg : '';
    Array.prototype.forEach.call(dd.querySelectorAll('.odd-opt'), function (o) {
      o.classList.toggle('sel', o.dataset.val === inf.nom);
    });
  }

  function construire() {
    var shades = racine(); if (!shades) return;
    var w = wrapper(); if (!w) return;
    var radios = w.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    /* Masquage inline a CHAQUE passage (le re-render recree le wrapper nu). */
    w.style.setProperty('display', 'none', 'important');

    if (w.dataset.oddFait === '1' && shades.querySelector('.odd')) return;
    w.dataset.oddFait = '1';
    var old = shades.querySelector('.odd');
    if (old) old.remove();

    var dd = document.createElement('div');
    dd.className = 'odd';
    dd.innerHTML =
      '<button type="button" class="odd-btn" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="odd-mini"></span><span class="odd-nom"></span><span class="odd-chev" aria-hidden="true"></span>' +
      '</button>' +
      '<div class="odd-list" role="listbox"></div>';
    var list = dd.querySelector('.odd-list');

    Array.prototype.forEach.call(radios, function (r, i) {
      var inf = infoDe(r, shades);
      var o = document.createElement('button');
      o.type = 'button';
      o.className = 'odd-opt' + (inf.disabled ? ' is-out' : '');
      o.setAttribute('role', 'option');
      o.dataset.val = inf.nom;
      o.dataset.i = i;
      var mini = document.createElement('span');
      mini.className = 'odd-mini';
      if (inf.bg && inf.bg !== 'none') mini.style.backgroundImage = inf.bg;
      var nom = document.createElement('span');
      nom.textContent = inf.nom;
      o.appendChild(mini); o.appendChild(nom);
      list.appendChild(o);
    });

    w.parentElement.insertBefore(dd, w);
    majBtn();
  }

  /* ---- delegation globale (survit aux re-renders, ne s'empile pas) ---- */
  document.addEventListener('click', function (e) {
    var shades = racine(); if (!shades) return;
    var dd = shades.querySelector('.odd'); if (!dd) return;

    var btn = e.target.closest ? e.target.closest('.odd-btn') : null;
    if (btn && dd.contains(btn)) {
      dd.classList.toggle('open');
      btn.setAttribute('aria-expanded', dd.classList.contains('open') ? 'true' : 'false');
      return;
    }

    var opt = e.target.closest ? e.target.closest('.odd-opt') : null;
    if (opt && dd.contains(opt)) {
      if (!opt.classList.contains('is-out')) {
        var radios = lesRadios();
        var r = radios[parseInt(opt.dataset.i, 10)];
        if (r) {
          var inf = infoDe(r, shades);
          if (inf.label) { inf.label.click(); }
          else { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        setTimeout(majBtn, 80);
      }
      dd.classList.remove('open');
      return;
    }

    if (!dd.contains(e.target)) dd.classList.remove('open');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var shades = racine(); if (!shades) return;
    var dd = shades.querySelector('.odd');
    if (dd) dd.classList.remove('open');
  });

  /* Un changement de teinte venu d'ailleurs (la galerie) : suivre. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.closest && t.closest('.orlea-pdp-shades')) setTimeout(majBtn, 80);
  }, true);

  function demarrer() {
    construire();
    new MutationObserver(function () { construire(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();